import { useRouter } from 'next/router';
import { useState } from 'react';
import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';
import Bundles from '../Bundles';
import ProductA from './ProductA';

export default function StatusItem() {
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    return (
        <>
            <ProductNav activeTab={defaultTab} tabCallback={tabCallback} />
            {activeTab === 'Product' && <ProductA />}
            {activeTab === 'Bundles' && <Bundles />}
        </>
    );
}
